module.exports = __webpack_public_path__ + "static/grafika1@2x-ca1bc5aec7b48f65320f5d3949dfddac.png";